import { createApp, h, reactive } from 'vue'
import StageUnlock from './views/StageUnlock.vue'
import { checkStageAccess } from './services/stageAccess'
import './styles/corporate-theme.css'

const state = reactive({ checking: true, locked: false, error: '' })
const gate = createApp({ render: () => h(StageUnlock, { unlock: startSite, checking: state.checking, locked: state.locked, initialError: state.error, retry: initialize }) })
gate.mount('#app')
window.addEventListener('stage-locked', () => window.location.reload())

async function startSite(checkedStatus) {
  const status = checkedStatus || await checkStageAccess()
  if (!status.authorized) throw new Error('Доступ не підтверджено. Введіть пароль ще раз.')
  const { start } = await import('./bootstrap')
  gate.unmount()
  await start()
  document.dispatchEvent(new Event('stage-unlocked'))
}
async function initialize() {
  state.checking = true
  state.error = ''
  state.locked = false
  try {
    const status = await checkStageAccess()
    if (status.authorized) await startSite(status)
    else if (!status.is_prod) {
      state.locked = true
      document.title = 'Тестовий сайт | Доступ обмежено'
    } else throw new Error('Не вдалося підтвердити доступ. Спробуйте ще раз.')
  } catch (error) {
    state.error = error.message
  } finally {
    state.checking = false
  }
}
initialize()
